import { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Typography from 'beam/dist/Typography'
import { CircularProgress } from 'beam/dist/Progress'
import Tooltip from 'beam/dist/Tooltip'
import withStyles from 'beam/dist/styles'

const styles = theme => ({
  center: {
    margin: 'auto auto',
  },
  surveyHeader: {
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap',
  },
  surveyTitle: {
    fontWeight: 700,
    flex: '1 1 auto',
  },
  surveyScore: {
    flex: '0 0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    color: theme.palette.text.hint,
  },
  postCallSurveyItem: {
    display: 'flex',
  },
  postCallSurveyLabel: {
    flex: '0 0 auto',
    display: 'inline-block',
    marginRight: theme.spacing(1),
    width: theme.spacing(13),
  },
  answerLabel: {
    flex: '1 1 auto',
    display: 'inline-block',
    marginRight: theme.spacing(1),
  },
  answerValue: {
    flex: '1 1 auto',
  },
  score: {
    marginLeft: theme.spacing(0.5),
    lineHeight: 1,
  },
  question: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1),
    width: theme.spacing(13),
  },
  scoreChip: {},
})

class PostCallSurveyPanel extends Component {
  static propTypes = {
    // TODO Remove once backend returns this in the survey API http://jira/browse/SAAS-45446
    surveyScoreOverride: PropTypes.string,
    survey: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.bool,
    onContactUpdate: PropTypes.func,
    t: PropTypes.func.isRequired,
    theme: PropTypes.object,
    classes: PropTypes.object,
    contactId: PropTypes.number,
  }

  static defaultProps = {
    // TODO Remove once backend returns this in the survey API http://jira/browse/SAAS-45446
    surveyScoreOverride: '',
    survey: null,
    error: false,
    onContactUpdate: () => {},
    theme: {
      spacing: x => x * 8,
    },
  }

  componentDidMount() {
    const { survey, contactId } = this.props

    if (!survey || survey.ccrId !== contactId) {
      this.refreshSurvey()
    }
  }

  componentDidUpdate(prevProps) {
    const { contactId } = this.props
    const contactIdChanged = prevProps.contactId !== contactId

    if (contactIdChanged) {
      this.refreshSurvey()
    }
  }

  refreshSurvey() {
    const { contactId, onContactUpdate } = this.props

    onContactUpdate(contactId)
  }

  renderLoading() {
    const { classes } = this.props
    return (
      <div className={classes.center}>
        <CircularProgress />
      </div>
    )
  }

  renderError() {
    const { t, classes } = this.props
    return (
      <div className={classes.center}>
        <Typography color="secondary" align="center">
          {t('error')}
        </Typography>
        <Typography color="secondary" align="center">
          {t('postCallSurveyDataError')}
        </Typography>
      </div>
    )
  }

  renderAnswer({ label }, index) {
    const { classes } = this.props

    return (
      <Typography variant="body1" key={index} className={classes.answerValue}>
        {label}
      </Typography>
    )
  }

  renderQuestion({ id, label, answers }) {
    const { classes } = this.props

    return (
      <div>
        <Typography variant="body2" color="textSecondary" paragraph className={classes.answerLabel}>
          {`${id}. ${label}`}
        </Typography>
        <Typography variant="body2" color="textPrimary" paragraph className={classes.answerValue}>
          {answers.map(this.renderAnswer.bind(this))}
        </Typography>
      </div>
    )
  }

  //Get this working from classlessness
  renderData() {
    const {
      survey: {
        survey: { name, id, questions, surveyScore },
      },
      t,
      classes,
      surveyScoreOverride,
    } = this.props

    const displayedSurveyScore = surveyScore ? surveyScore : surveyScoreOverride
    return (
      <div>
        <Typography variant="body1" color="textPrimary" paragraph className={classes.surveyTitle}>
          {t(['postCallSurvey', 'Post Call Survey'])}
        </Typography>
        <div className={classes.surveyHeader}>
          <div className={classes.postCallSurveyItem}>
            <Typography variant="body1" color="textSecondary" paragraph className={classes.postCallSurveyLabel}>
              {t('postCallSurveyName')}
            </Typography>
            <Typography variant="body1" color="textPrimary" paragraph className={classes.answerValue}>
              <Tooltip title={`${t('surveyIdentifier')}: ${id}`}>
                <Typography variant="body1">{name}</Typography>
              </Tooltip>
            </Typography>
          </div>
          <div className={classes.postCallSurveyItem}>
            <Typography variant="body1" color="textSecondary" paragraph className={classes.postCallSurveyLabel}>
              {t(['surveyScore', 'Survey Score'])}
            </Typography>
            <Typography variant="body1" color="textPrimary" paragraph className={classes.answerValue}>
              {displayedSurveyScore}
            </Typography>
          </div>
        </div>
        {questions.map(this.renderQuestion.bind(this))}
      </div>
    )
  }

  render() {
    const { loading, survey, error } = this.props
    return loading || error || survey ? (
      <section aria-label="postCallSurvey">
        {(loading && this.renderLoading()) || (error && this.renderError()) || (survey && this.renderData())}
      </section>
    ) : null
  }
}

export { PostCallSurveyPanel as UnstyledPostCallSurveyPanel }
export default withTranslation()(withStyles(styles, { withTheme: true })(PostCallSurveyPanel))
